import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RoutingHub } from "@/features/operator/routing/RoutingHub";

export const Route = createFileRoute("/app/operator/routing/")({
  validateSearch: z.object({
    view: z.string().optional(),
    node: z.string().optional(),
    section: z.enum(["default", "users"]).optional().catch(undefined),
    user: z.string().optional(),
    tenant: z.string().optional(),
  }),
  component: RoutingHub,
});
